class DonationsApi {
    constructor(api) {
        this.api = api;
    }

    createIntent(data) {
        return this.api.requestPost(this.api.route('donate.create'), data, {
            withSession: true,
        });
    }

    confirmIntent(data) {
        return this.api.requestPost(this.api.route('donate.confirm'), data, {
            withSession: true,
        });
    }
}

export default DonationsApi;
